module.exports = function () {
    return {
        require: 'ngModel',
        restrict: 'A',
        link: (scope, elem, attr, ngModel) => {
            scope.options = attr.wowNameLengthWarnings ? JSON.parse(attr.wowNameLengthWarnings) : [];

            // For DOM -> model validation
            ngModel.$parsers.unshift((value) => {
                let preferredOption;
                scope.options.forEach((option) => {
                    if (value.length >= option.length) {
                        if (!preferredOption || option.length > preferredOption.length) {
                            preferredOption = option;
                        }
                    }
                    if (ngModel[option.type]) {
                        delete ngModel[option.type][option.name];
                    }
                });
                if (preferredOption) {
                    if (!ngModel[preferredOption.type]) {
                        ngModel[preferredOption.type] = {};
                    }
                    ngModel[preferredOption.type][preferredOption.name] = true;
                }
                return value;
            });

            // For model -> DOM validation
            ngModel.$formatters.unshift((value) => {
                let preferredOption;
                scope.options.forEach((option) => {
                    if (value.length >= option.length) {
                        if (!preferredOption || option.length > preferredOption.length) {
                            preferredOption = option;
                        }
                    }
                    if (ngModel[option.type]) {
                        delete ngModel[option.type][option.name];
                    }
                });
                if (preferredOption) {
                    if (!ngModel[preferredOption.type]) {
                        ngModel[preferredOption.type] = {};
                    }
                    ngModel[preferredOption.type][preferredOption.name] = true;
                }
                return value;
            });
        },
    };
};



// WEBPACK FOOTER //
// ./src/common/namelengthwarnings/name-length-warnings.directive.js